<template>
    <label class="checkbox-wrapper">
        <input type="checkbox"
               :value="inputValue"
               v-model="comModel" />

        <IconCheckboxOff class="icon-off" />

        <IconCheckboxOn class="icon-on" />

        <span class="checkbox-label">{{ label }}</span>
    </label>
</template>

<script>
import IconCheckboxOff from './icons/IconCheckboxOff.vue';
import IconCheckboxOn from './icons/IconCheckboxOn.vue';

export default {
    name: 'CheckboxButton',
    components: {
        IconCheckboxOff,
        IconCheckboxOn,
    },
    props: {
        inputValue: { type: null, required: false },
        value: { type: null },
        label: { type: String, required: true },
    },
    computed: {
        comModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    width: fit-content;

    cursor: pointer;
    line-height: 20px;

    input[type="checkbox"] {
        display: none;
    }

    .icon-on,
    .icon-off {
        position: absolute;
        left: 0;

        width: 20px;
        height: 20px;

        vertical-align: middle;
        transition: opacity 0.1s ease;
    }

    .icon-on,
    input[type="checkbox"]:checked+.icon-off {
        opacity: 0;
    }

    .icon-off,
    input[type="checkbox"]:checked+.icon-off+.icon-on {
        opacity: 1;
    }

    .checkbox-label {
        padding-left: 32px;

        font-weight: 400;
        font-size: 14px;

        color: var(--text-primary);
    }
}
</style>